import { InsetWrapper } from '@showclix-shared/CheckoutProcess/components/InsetWrapper';

export default InsetWrapper;
